import { ETheme } from "@/DependenciesV9";
import { RootState } from "@/redux";
import {
  BodyContentRightWrapper,
  ContentRightWrapper,
  ContentWrapper,
  HeaderContentRightWrapper,
} from "@/views/layout/content/Style.ts";
import Organization from "@/views/organizations/OrganizationContainer";
import Tenant from "@/views/tenants/TenantContainer";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router";
import SideBar from "../side-bar";
import { Navigate } from "react-router-dom";

const Content = () => {
  const theme: ETheme = useSelector(
    (state: RootState) => state.settingInfo?.theme,
  );
  const workingTenant: ETheme = useSelector(
    (state: RootState) => state.settingInfo?.workingTenant,
  );

  return (
    <ContentWrapper className="ContentWrapper" $theme={theme}>
      <SideBar />
      <ContentRightWrapper className="ContentRightWrapper">
        <HeaderContentRightWrapper className="HeaderContentRightWrapper">
          Tenant
        </HeaderContentRightWrapper>
        <BodyContentRightWrapper className="BodyContentRightWrapper">
          <Routes>
            <Route path="/" element={<Navigate to={`${workingTenant}/tenants`} replace />} />
            <Route path=":tenantId/tenants" element={<Tenant />} />
            <Route path=":tenantId/organizations" element={<Organization />} />
          </Routes>
        </BodyContentRightWrapper>
      </ContentRightWrapper>
    </ContentWrapper>
  );
};

export default Content;
